gxg-paginator {
  display: flex;
  flex-direction: column;
  padding-top: var(--spacing-comp-01);
  padding-bottom: var(--spacing-comp-01);
  /*Alignment*/
}
gxg-paginator[alignment=start] {
  align-items: flex-start;
}
gxg-paginator[alignment=center] {
  align-items: center;
}
gxg-paginator[alignment=end] {
  align-items: flex-end;
}

gxg-paginator[alignment=end] {
  align-items: flex-end;
}

ch-paginator {
  display: flex;
  background-color: var(--color-background);
  gap: var(--spacing-comp-01);
  justify-content: center;
}

ch-paginator-navigate,
ch-paginator-pages::part(button) {
  width: var(--spacing-comp-05);
  height: var(--spacing-comp-05);
  cursor: pointer;
  background-color: transparent;
}
ch-paginator-navigate:hover,
ch-paginator-pages::part(button):hover {
  color: var(--color-primary-hover);
}

ch-paginator-pages::part(button) {
  color: var(--gray-04);
}

ch-paginator-pages::part(active) {
  color: var(--color-primary-hover);
  font-weight: var(--font-weight-semibold);
}

ch-paginator-navigate {
  display: inline-block;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

ch-paginator-navigate[type=first]:before,
ch-paginator-navigate[type=previous]:before,
ch-paginator-navigate[type=next]:before,
ch-paginator-navigate[type=last]:before {
  content: "";
  display: block;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: contain;
  width: 100%;
  height: 100%;
  background-color: var(--gray-04);
}
ch-paginator-navigate[type=first]:hover:before,
ch-paginator-navigate[type=previous]:hover:before,
ch-paginator-navigate[type=next]:hover:before,
ch-paginator-navigate[type=last]:hover:before {
  background-color: var(--color-primary-hover);
}

ch-paginator-navigate[type=first]:before {
  -webkit-mask-image: var(--navigateFirstUrl);
}

ch-paginator-navigate[type=previous]:before {
  -webkit-mask-image: var(--navigatePrevUrl);
}

ch-paginator-navigate[type=next]:before {
  -webkit-mask-image: var(--navigateNextUrl);
}

ch-paginator-navigate[type=last]:before {
  -webkit-mask-image: var(--navigateLastUrl);
}

ch-paginator-pages::part(pages) {
  display: flex;
  gap: var(--spacing-comp-01);
}

ch-paginator-pages::part(button) {
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-family-primary);
}

ch-paginator-pages::part(button):focus-visible,
ch-paginator-navigate:focus-visible {
  outline: 2px solid var(--color-primary-active);
}